// import store from '@/xreports/store/index'
// import { MessageBox } from 'element-ui'
// import { Dialog } from 'vant'
import loadComponentsByCondition from '@/utils/load-components-by-condition'
export const messageBox = ({ type, title, message, confirmButtonText, showCancelButton = false }) => {
  const isMobile = window.innerWidth < 1024
  let p = new Promise((resolve, reject) => {
    loadComponentsByCondition(
      {
        mobile: {
          Vant: () => import('vant'),
        },
        pc: {
          Element: () => import('element-ui'),
        },
      },
      isMobile ? 'mobile' : 'pc',
      ({ Vant, Element }) => {
        if (Vant) {
          Vant.Dialog.confirm({
            title: title,
            message: message,
            confirmButtonText: confirmButtonText,
            showCancelButton,
          })
            .then(resolve)
            .catch(reject)
        } else {
          Element.MessageBox.confirm(message, title, {
            confirmButtonText: confirmButtonText,
            type: type,
            showCancelButton,
          })
            .then(resolve)
            .catch(reject)
        }
      }
    )
  })
  return p
}
